module.exports = __webpack_public_path__ + "static/media/covi_too_min_pap.a016e08b.png";